import { Email, Sms } from '@mui/icons-material'

import { preview } from '@/components/form/preview'
import { BackupEmailSubject } from '../../../../components/BackupEmailSubject'
import { NotificationPreview } from '../../../../components/NotificationPreview'
import { NotificationLimitations } from './components/NotificationLimitations'

import { useComputeSegmentsCount } from '@/hooks'
import type { AlmostThereNotificationValues } from '../../hooks/useAlmostThereNotificationValues'

import { useTexts } from './useTexts'

interface Props {
  values: AlmostThereNotificationValues
}

export function AlmostThereNotificationView(props: Props) {
  const { values } = props
  const texts = useTexts()

  const isEmailNotification = values.notificationWay === 'EMAIL'
  const isPhoneNotification = !isEmailNotification

  const notificationWay = values.notificationWay === 'PHONE' ? 'SMS' : 'Email'

  const segmentsCount = useComputeSegmentsCount(
    { ...values.templateDefaultLimits, ...values.templateCustomLimits },
    values.templateCustom,
    isEmailNotification
      ? values.includeMessageUnsubscriptionInstructionsEmail
      : values.includeMessageUnsubscriptionInstructionsPhone,
    values.includeMessageTrackingLink,
  )

  return (
    <>
      {/* Notification Limitations */}
      <NotificationLimitations />

      {/* Notification Threshold */}
      <preview.Field testId="notification-threshold" label={texts.proximityThresholdMins}>
        {texts.proximityThresholdMinsValue(values.proximityThresholdMins)}
      </preview.Field>

      {/* Notification Type */}
      {isEmailNotification && (
        <NotificationPreview
          icon={<Email color="action" />}
          notificationType={notificationWay}
          subject={values.subjectCustom}
          templatePreview={values.templatePreview}
        />
      )}

      {isPhoneNotification && (
        <>
          {/* SMS Body */}
          <NotificationPreview
            icon={<Sms color="action" />}
            notificationType={notificationWay}
            templatePreview={values.templatePreview}
            additionalTextDetails={texts.segmentsCount(segmentsCount)}
          />

          {/* E-mail backup subject */}
          {values.backupNotification && (
            <BackupEmailSubject
              icon={<Email color="action" />}
              subject={values.backupSubjectCustom}
            />
          )}
        </>
      )}
    </>
  )
}
